import { useUBL } from '@common/log-manager';

export const convertRecommendType = (group_type: string) => group_type.replace('_item_list', '').replace('store_', '');

export const useAdReivewLog = (originalProductId: string) => {
  const sendUBL = useUBL();

  const commonLog = {
    navigation: 'product_detail',
    object_section: 'ad_review_carousel',
    object_type: 'catalog',
    object_idx: 0,
  };

  const impressionProductItem = ({
    title,
    log,
    productId,
    index,
  }: {
    title: string;
    log: string;
    productId: string;
    index: number;
  }) =>
    sendUBL({
      ...commonLog,
      category: 'impression',
      object_id: productId,
      data: {
        title: title,
        original_product_id: originalProductId,
        item_idx: index,
        server_log: log,
      },
    });

  const clickProductItem = ({
    title,
    log,
    position,
    productId,
    index,
  }: {
    title: string;
    log: string;
    position: number;
    productId: string;
    index: number;
  }) =>
    sendUBL({
      ...commonLog,
      category: 'click',
      object_idx: position,
      object_id: productId,
      data: {
        title: title,
        original_product_id: originalProductId,
        item_idx: index,
        server_log: log,
      },
    });

  const savedProduct = ({
    title,
    log,
    category,
    productId,
    index,
  }: {
    title: string;
    log: string;
    category: 'save_product' | 'remove_saved_product';
    productId: string;
    index: number;
  }) => {
    sendUBL({
      ...commonLog,
      category,
      object_id: productId,
      data: {
        title: title,
        original_product_id: originalProductId,
        item_idx: index,
        server_log: log,
      },
    });
  };

  const viewMore = () =>
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'subtab_recommendation',
      object_type: 'button',
      object_id: 'see_more_item',
    });

  return {
    impressionProductItem,
    clickProductItem,
    savedProduct,
    viewMore,
  };
};
